const ALL_ENDPOINTS = '*';
const LOGOUT_BLOCKING_STATUSES = new Set(['logging_out', 'logout_error']);

const ACCOUNT_ENDPOINTS = Object.freeze({
  authApi: Object.freeze([
    'getAuthMe',
    'twitchSignIn',
    'twitchCodeAuth'
  ]),
  userApi: ALL_ENDPOINTS,
  donatesApi: ALL_ENDPOINTS,
  donateRecordsApi: Object.freeze([
    'getAuctionDonateRecords',
    'removeAuctionDonateRecord',
    'removeAuctionDonateRecords'
  ]),
  eventRecordsApi: ALL_ENDPOINTS,
  donateVariantsApi: Object.freeze([
    'getDonateVariants',
    'getDonateVariant',
    'createDonateVariant',
    'updateDonateVariant',
    'deleteDonateVariant'
  ]),
  paymentOptionsApi: Object.freeze([
    'getPaymentOptions',
    'updatePaymentOption',
    'generateDonatelloApiKey'
  ]),
  rouletteWidgetApi: Object.freeze([
    'getRoulette',
    'updateRouletteWidget',
    'getRouletteCategory',
    'createRouletteCategory',
    'updateRouletteCategory',
    'partialUpdateRouletteCategory',
    'uploadRouletteCategoryImage',
    'deleteRouletteCategoryImage',
    'deleteRouletteCategory'
  ]),
  emotesApi: Object.freeze(['getCurrentUserEmotes']),
  interactionsApi: Object.freeze(['createInteraction', 'sendInteraction'])
});

export const isAccountEndpoint = (clientName, endpointName) => {
  const endpoints = ACCOUNT_ENDPOINTS[clientName];
  return endpoints === ALL_ENDPOINTS || endpoints?.includes(endpointName) || false;
};

export const shouldBlockAccountRequest = (state, clientName, endpointName) => (
  LOGOUT_BLOCKING_STATUSES.has(state?.auth?.status)
  && isAccountEndpoint(clientName, endpointName)
);
